import React, { Component } from "react";
import { Sticky, Grid } from "semantic-ui-react";
import { Link } from "react-router-dom";

class CheckAvailabilityHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileMenuSwitch: false,
    };

    this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
    this.checkScreenSize = this.checkScreenSize.bind(this);
  }

  toggleMobileMenu(event) {
    this.setState({
      mobileMenuSwitch: !this.state.mobileMenuSwitch,
    });
  }

  componentDidMount() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  }
  checkScreenSize() {
    if (document.querySelector(".is-zoom")) {
      document.querySelector("body").classList.remove("is-zoom");
    }
    let originalScreenWidth = window.outerWidth;
    if (originalScreenWidth >= 1920) {
      document.querySelector("body").style.zoom = "125%";
    } else {
      document.querySelector("body").style.zoom = null;
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  }

  render() {
    const { stickyContext } = this.props;
    return (
      <div className="ui vertical segment py-0 border-0 default header__check-availability">
        <Sticky context={stickyContext} className="sticky-header-container">
          <div className="sticky-nav">
            <div className="nav">
              <div className="ui container">
                <Grid>
                  <Grid.Row className="py-0">
                    <Grid.Column
                      className="align-vertical"
                      floated="left"
                      width={8}
                    >
                      <h2 className="no-decoration text-prime  itc-mdbold mb-0 default-logo">
                        <Link to={"/"}>
                          Fibre
                          <span className="normal itc-std-md text-stream">
                            Stream
                          </span>
                        </Link>
                      </h2>
                    </Grid.Column>
                    <Grid.Column floated="right" width={3} textAlign="right">
                      <div className="ui text menu right aligned link--signin">
                        {/*<a
                          href="https://my.freshbooks.com"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="ui item"
                        >
                          Sign In
                        </a>*/}
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            </div>
          </div>
        </Sticky>
      </div>
    );
  }
}

export default CheckAvailabilityHeader;



// WEBPACK FOOTER //
// ./src/components/header/CheckAvailabilityHeader.js